module.exports = __webpack_public_path__ + "img/img_side_ginkgo.c7402da8.png";